import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import './CommonModal.css';

// Clean up Bootstrap modal DOM artifacts only when no other modals remain open
const cleanupModalArtifacts = () => {
    requestAnimationFrame(() => {
        setTimeout(() => {
            try {
                const visibleModals = document.querySelectorAll('.modal.show, .modal[style*="display: block"]');
                if (visibleModals.length === 0) {
                    document.querySelectorAll('.modal-backdrop').forEach(backdrop => {
                        if (backdrop && backdrop.parentNode) backdrop.remove();
                    });
                    if (document.body) {
                        document.body.classList.remove('modal-open');
                        document.body.style.overflow = '';
                        document.body.style.paddingRight = '';
                    }
                }
            } catch (error) {
                console.debug('Modal cleanup error (safe to ignore):', error);
            }
        }, 150);
    });
};

const CommonModal = ({ title, children, footer, modalStatus, classList, changeActiveStatus = () => { }, lightBox = false, closeModalOnEsc = true, showFooter = true, hideCloseIcon = false, ...rest }) => {
    const [show, setShow] = useState(false);
    
    useEffect(() => {
        setShow(modalStatus);
    }, [modalStatus]);

    const handleClose = useCallback(() => {
        setShow(false);
        // Delay parent notification and cleanup so the exit animation (e.g. hide towards top) runs
        // before the parent unmounts the modal. Same behaviour for close button and Escape.
        setTimeout(() => {
            changeActiveStatus(false);
            cleanupModalArtifacts();
        }, 300);
    }, [changeActiveStatus]);

    // Handle Enter key to trigger Yes button
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Enter' && modalStatus) {
                const yesButton = document.querySelector('.common-modal-yes-button button');
                if (yesButton) {
                    yesButton.click();
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [modalStatus]);

    return (
        <Modal
            scrollable={true}
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={closeModalOnEsc}
            className={`${classList != undefined ? classList : ''} ${lightBox ? 'lightboxModal' : ''} ${lightBox && typeof window !== 'undefined' && window.self !== window.top ? 'insideIframe' : ''}`}
            {...rest}
        >
            {!lightBox &&
                <Modal.Header closeButton={!hideCloseIcon} className="cursor-grab">
                    <Modal.Title>
                        {title ?? ''}
                    </Modal.Title>
                    {!hideCloseIcon &&
                        <div className='d-flex'>
                            <FontAwesomeIcon onClick={handleClose} icon={faXmark} className='au-modal-close-btn' />
                        </div>
                    }
                </Modal.Header>
            }
            <Modal.Body>
                {children}
            </Modal.Body>
            {lightBox && (
                <button className="lightbox-close-btn" onClick={handleClose} aria-label="Close">
                    <FontAwesomeIcon icon={faXmark} />
                </button>
            )}
            {showFooter && !lightBox && (
                <Modal.Footer>
                    {footer}
                </Modal.Footer>
            )}
        </Modal>
    )
}
export default React.memo(CommonModal);